import { Component, Inject, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ConfirmationDialogData } from './confirmation-dialog-config';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ConfirmationDialogComponent {
  public messageText: string;
  public messageTitle: string;
  public type: string;
  public value: any;
  public proceedButtonText: string;
  public cancelButtonText: string;
  public proceedButtonText_2: string;
  public showDontAskAgain: boolean = false;
  public dontAskAgain: boolean = false;
  public cancelButtonIsNotRequired: boolean = false;
  public panelClass: string;
  private readonly router = inject(Router);
  // Enter confirms on keyup, so the keyup of an Enter that opened the dialog from a button or menu item must not count.
  private enterPressedHere = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData,
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
  ) {
    this.messageText = data.text ? data.text : 'generic.confirmDeleteDialog.message';
    this.messageTitle = data.title ? data.title : 'confirmationDialog.confirmationTitle';
    this.type = data.type ? data.type : '';
    this.value = data.value;
    this.proceedButtonText = data.proceedButtonText;
    this.cancelButtonText = data.cancelButtonText;
    this.proceedButtonText_2 = data.proceedButtonText_2;
    this.showDontAskAgain = data.showDontAskAgain;
    this.cancelButtonIsNotRequired = data.cancelButtonIsNotRequired;
    this.panelClass = data.panelClass;
  }

  public onKeyUp(event: KeyboardEvent) {
    event.preventDefault();
    event.stopPropagation();
    switch (event.keyCode) {
      case 32:
        console.log('Space clicked');
        this.dialogRef.close(false);
        break;
      case 27:
        console.log('Esc clicked');
        this.dialogRef.close(false);
        break;
      case 13:
        if (this.enterPressedHere) {
          this.dialogRef.close(true);
        }
        break;
      default:
    }
  }

  public onEnterDown(event: Event) {
    event.preventDefault();
    this.enterPressedHere = true;
  }

  // A full page load leaves the open dialog in Chrome's back/forward cache, so Back shows it again.
  public onContentClick(event: MouseEvent) {
    if (!this.data.routeInternalLinks || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey) {
      return;
    }
    const href = (event.target as HTMLElement).closest('a')?.getAttribute('href');
    if (!href?.startsWith('/')) {
      return;
    }
    event.preventDefault();
    this.dialogRef.close(false);
    this.router.navigateByUrl(href);
  }

  public submit({ event, secondary }) {
    event.stopPropagation();
    event.preventDefault();
    if (this.showDontAskAgain) {
      this.dialogRef.close({ submit: true, dontAskAgain: this.dontAskAgain });
    } else if (this.proceedButtonText_2 === undefined) {
      this.dialogRef.close(true);
    } else {
      this.dialogRef.close({ submit: true, secondary });
    }
  }

  public cancel(event) {
    event.stopPropagation();
    event.preventDefault();
    this.dialogRef.close(false);
  }
}
